import React from "react";
import Cookies from 'universal-cookie';

export function gatewayUrl(){return "ssh://ubuntu@3.128.137.10"};
export function deviceAppUrl(){return "ssh://ubuntu@18.117.137.76"};

// download a json file
export function downloadJsonFile( fileName, json, date){
    downloadFile( fileName, json, 'json', date);
}

// download any file
export async function downloadFile( fileName, json, ext, date){
    if(!date){
        date=new Date();
    }
    const blob = new Blob([json],{type:'application/'+ext});
    const href = await URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.download = fileName + formatDateForFileName(date) + "." + ext;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

// format dates
const zeroPad = (num, places) => String(num).padStart(places, '0')
export function formatDateTime(d){
    if(d===undefined || d===""){
        return "";
    }
    var dt = new Date(d);
    let result =
        (zeroPad(dt.getMonth()+1,2)) +"/"
        +zeroPad(dt.getDate(),2)+"/"
        +dt.getFullYear()
        + " "+zeroPad(dt.getHours(),2)
        +":"+zeroPad(dt.getMinutes(),2);
    return result;
}
export function colorFormatDateTime(action_d, server_d, yellowMinutes, redMinutes){
    let result="";
    let hover=`Action-string:${action_d}\n`
    hover+=`Server-string:${server_d}\n`
    try {
        var actionDate = new Date(action_d);
        var serverDate = new Date(server_d);
        var localDate = new Date();
        let timeZoneOffset=serverDate-localDate;
        let localActionDate=actionDate-timeZoneOffset;

        hover+=`Action-date:${actionDate}\n`
        hover+=`Server-date:${serverDate}\n`
        hover+=`Local-date:${localDate}\n`
        hover+=`Time Zone Offset:${timeZoneOffset}\n`

        var diffMs = (serverDate-actionDate); // milliseconds between now & action
        var diffInMinutes=diffMs/1000/60;
        //hover+=`Diff in minutes:${diffInMinutes}\n`

        var diffDays = Math.floor(diffMs / 86400000); // days
        var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
        var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
        hover+=diffDays + " days, " + diffHrs + " hours, " + diffMins + " minutes\n";
        
        // set color
        let color="green";
        if(diffInMinutes>redMinutes){ color="red"}
        else if(diffInMinutes>yellowMinutes){color="gold"}
        hover+=`${color} minutes since:${diffInMinutes} red:${redMinutes} yellow:${yellowMinutes}`;
        result=formatDateTime(localActionDate);
        if(result.indexOf("/Na")>0){
            result="unk";
        }
        result=`<span style="color:${color}" title="${hover}">${result}</span>`;
    } catch (ex){}
    return result;
}
export function formatDate(d){
    if(d===undefined || d===""){
        return "";
    }
    var dt = new Date(d);
    let result =
        (zeroPad(dt.getMonth()+1,2)) +"/"
        +zeroPad(dt.getDate(),2)+"/"
        +dt.getFullYear()
    return result;
}
// format date for a file name
function formatDateForFileName(d){
    if(d===undefined || d===""){
        return "";
    }
    var dt = new Date(d);
    let result =
        dt.getFullYear()+"-"
        +zeroPad(dt.getMonth()+1,2) +"-"
        +zeroPad(dt.getDate(),2)+"-"
        +zeroPad(dt.getHours(),2)+ "-"
        +zeroPad(dt.getMinutes(),2);
    return result;
}
// create a react date
export function reactDate(d){
    let result="";
    if(d!==null){
        result = formatDateTime(d);
    }
    return React.createElement('span',{},
                    result
                );
}
// show an astrisk  if modified
export function showModified(val){
    if(val){return "*"} else {return ""}
}
// open a window
export function openWindow(url, target, windowFeatures){
    try {
        window.open( url , target, windowFeatures)
    } catch(e){
        window.alert(e.message);
    }
}
export async function copyToClipBoard(text) {
    var input = document.createElement('textarea');
    input.innerHTML = text;
    document.body.appendChild(input);
    input.focus();
    input.select();
    var result = "";
    try{
        result=document.execCommand('copy');
        if(!result){
            await navigator.clipboard.writeText(text).then(
                () => {
                  /* clipboard successfully set */
                },
                () => {
                  alert('clipboard write failed');
                },
              );
        }

    } catch(ex){
        alert(ex);
    }
    document.body.removeChild(input);
    return result;
}
export function openUpdateHubScript(){
    window.open("https://github.com/wave-dds/wave-v2/blob/develop/scripts/SendHubDataToWaveDeviceServer.sh?cellPassword=Wave*12345");
}

export function openInstructionBook(){
    window.open("https://docs.google.com/document/d/1td85DZglLQ-b1mxXEIeRMca_NzY-Id2La2IkMLbki6Q/edit#");
}

export function isMobile(){
    return window.innerWidth<900;
}

//export function updateHubScriptCommand(hostname){
//    copyToClipBoard(getUpdateHubScriptCommand(hostname));    
//}

//export function getUpdateHubScriptCommand(hostname){
//    return updateHubCommand(+" ")+hostname;
//}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export function DeviceAppMenuCommand(){
    return "cd ~/wave-device-tracking-app/scripts/device_app_server;./menu.sh"
}
export function getDeviceAppMenuCommandForBastionHost(host){
    let clipBoard=DeviceAppMenuCommand()+" "+host;
    copyToClipBoard(clipBoard);
    return deviceAppUrl();
}  
export function updateHubCommand5(){
    return "cd /home/ubuntu/wave-device-tracking-app/scripts/bastionhost_server/;./UpdateHubDataFromAWSGateway7.sh"
}
export function getUpdateHubCommandForBastionHost5(host, logInId){
    let clipBoard=updateHubCommand5()+" "+host + " " + logInId;
    copyToClipBoard(clipBoard);
    return gatewayUrl();
}  
export function updateHubCommand7(host,logInId,port){
    return `ssh ubuntu@10.0.0.43 "cd wave-device-tracking-app/scripts/device_app_server/;./UpdateHubData.sh ${host} ${logInId} ${port};exit"`
}
export function getUpdateHubCommandForBastionHost7(host, logInId, port){
    let clipBoard=updateHubCommand7(host,logInId,port);
    copyToClipBoard(clipBoard);
    return gatewayUrl();
}  

export function getFindHtmlUrl(){
    let url=window.location.href+"/FindHub.html";
    console.log(url);
    return url;
}
export function getSSHUrlForGateway(host,user){
    let clipBoard=`ssh ${user}@${host}`;
    //+" -pw "+ this.state.hub.processor_password;
    copyToClipBoard(clipBoard);
    return gatewayUrl();
}  
export function getSSHUrlForBeaconConfig(){
    //let clipBoard="cd wave-beacon-programming/;node AutomatedBeaconUpdate.js";
    let clipBoard=`ssh pi@factorypi.hubs.wavedds.com -t "cd wave-beacon-programming/;node AutomatedBeaconUpdate.js"`;
    copyToClipBoard(clipBoard);
    return gatewayUrl();
}  
export function getSSHToFactoryPiCommand(){
    return`ssh pi@factorypi.hubs.wavedds.com`;
}
function downloadURI(uri, name) {
    let link = document.createElement("a");
    link.download = name;
    link.href = uri;
    link.click();
}

export function downloader(data, type, name) {
    let blob = new Blob([data], {type});
    let url = window.URL.createObjectURL(blob);
    downloadURI(url, name);
    window.URL.revokeObjectURL(url);
}
export function getCookieValue(name,defaultValue){
    let cookies = new Cookies();
    let val=cookies.get(name);
    if(!val){
        val=defaultValue;
    }
    return val;

}

export function saveCookieValue(name,value){

    const cookies = new Cookies();
    let nextYear = new Date();
    const current = new Date();
    nextYear.setFullYear(current.getFullYear() + 1);

    cookies.set( name, value,
                            {
                                path: '/',
                                expires: nextYear,
                            }
    );        
} 
export function saveCookieValueFromEvent(event){
    saveCookieValue(event.target.name,event.target.value);
} 
export function normalizeInputForMacAddress(event){
    let regexMac = new RegExp(/^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})|([0-9a-fA-F]{4}.[0-9a-fA-F]{4}.[0-9a-fA-F]{4})$/);
    if( regexMac.test(event.currentTarget.value) && event.currentTarget.value.length===17 ){
        event.currentTarget.value=event.currentTarget.value.toUpperCase().replaceAll("-",":");
    }
    let regexMac2 = /^[0-9a-fA-F]+$/;
    if( regexMac2.test(event.currentTarget.value) && event.currentTarget.value.length===12 ){
        event.currentTarget.value=event.currentTarget.value.toUpperCase();
        event.currentTarget.value = event.currentTarget.value.replace(/(..)/g, '$1:').slice(0,-1)
    }
}
export function normalizeInputForSerialNumber(event){
        event.currentTarget.value=event.currentTarget.value.toUpperCase();
        event.currentTarget.value = event.currentTarget.value.replaceAll(':','')
}
export function getHubspotPortalId(){
    let portalId=getCookieValue('HubspotPortalId',"5528322");
    return portalId;
}

export function openOrder(source, source_order_id){
    if(source==='katana'){
        openWindow(`https://factory.katanamrp.com/salesorder/${source_order_id}`)        
    }
    if(source==='deal'){
        openWindow(`https://app.hubspot.com/contacts/5528322/record/0-3/${source_order_id}`)        
    }    
}
export function openCustomer(source, source_customer_id){
    if(source==='katana'){
        openWindow(`https://factory.katanamrp.com/customer/${source_customer_id}`)        
    }       
    if(source==='deal'){
        openWindow(`https://app.hubspot.com/contacts/5528322/record/0-2/${source_customer_id}`)        
    }      
}
export function getHubspotCompanyLink(companyId){
    let portalId=getHubspotPortalId();
    return `https://app.hubspot.com/contacts/${portalId}/record/0-2/${companyId}`;
} 
export function openHubspotCompany(companyId){
    openWindow(getHubspotCompanyLink(companyId));
}   
export function openKatanaCompany(companyId ){
    openWindow(`https://factory.katanamrp.com/customer/${companyId}`);
}

